import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDesignations,
  createDesignationRequest,
  deleteDesignation
} from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from 'sweetalert2';
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Designation = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { designations, loading, success, error } = useSelector((state) => state.DesignationMaster || {});
  const [authDetails, setAuthDetails] = useState(null);

  // useEffect(() => {
  //   if (loading) {
  //     dispatch(fetchDesignations(authDetails?.unit_id));
  //   }
  // }, [loading, authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchDesignations(unitId));
  }, [dispatch]);

  const [data, setData] = useState([
    { id: 1, designation: "Senior manager", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 2, designation: "Production Supervisor", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 3, designation: "Office Assistant", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 4, designation: "Junior Engineer", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 5, designation: "Cash officer", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 6, designation: "Assistant manager", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 7, designation: "Assistant Engineer", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 8, designation: "Apprentice", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 9, designation: "General admin", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 10, designation: "General admin", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 11, designation: "General admin", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
    { id: 12, designation: "General admin", createdBy: "AES ADMIN", createdOn: "03-04-2024" },
  ]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      desig_id: 0,
      desig_name: "",
      created_by: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    },
    validationSchema: Yup.object({
      desig_name: Yup.string()
        .required("Please Enter Designation")
        .max(50, "Designation must not exceed 50 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Designation allows only alphabets, numbers and spaces"
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("desig_id", values.desig_id);
      formData.append("desig_name", values.desig_name);
      formData.append("unit_id", values.unit_id);
      formData.append("created_by", values.created_by);

      dispatch(createDesignationRequest(formData, isEdit));
      setIsEdit(false);
      formik.resetForm();
    },
  });

  const handleEdit = (row) => {
    formik.setValues({
      desig_id: row.desig_id,
      desig_name: row.designation,
      created_by: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  // const columns = [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => {
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //           <Link
  //             to="#"
  //             className="text-danger"
  //             onClick={() => {
  //               handleToggleStatus(cellProps.row.original);
  //             }}
  //           >
  //             <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //             <UncontrolledTooltip placement="top" target="deletetooltip">
  //               Delete
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => designations.length - row.index,
  //     className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   {
  //     Header: "Designation",
  //     accessor: "designation",
  //   },
  //   {
  //     Header: "Created By",
  //     accessor: "createdby",
  //   },
  //   {
  //     Header: "Created On",
  //     accessor: "createddate",
  //   },
    
  // ];
  const columns = useMemo(() => {
    const actionColumn = (canEdit || canDelete)
      ? {
          Header: "Action",
          Cell: (cellProps) => {
            const { id } = cellProps.row.original; // Must be unique field
            return (
              <div className="d-flex gap-3">

                {/* Edit Button */}
                {canEdit && (
                  <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                  >
                    <i
                      className="bx bxs-edit font-size-18"
                      id={`edit-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`edit-tooltip-${id}`}
                    >
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                )}

                {/* Delete Button */}
                {canDelete && (
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => handleToggleStatus(cellProps.row.original)}
                  >
                    <i
                      className="mdi mdi-delete font-size-18"
                      id={`delete-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`delete-tooltip-${id}`}
                    >
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                )}
              </div>
            );
          },
        }
      : null;

    return [
      ...(actionColumn ? [actionColumn] : []),
      {
        Header: "S.No",
        Cell: ({ row }) => designations.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Designation", accessor: "designation" },
      { Header: "Created By", accessor: "createdby" },
      { Header: "Created On", accessor: "createddate" },
    ];
  }, [designations, canEdit, canDelete]);


  const handleToggleStatus = (row) => {
    console.log('row > ', row)
    Swal.fire({
      title: 'Are you sure?',
      html: `You are about to delete <strong>${row.designation}</strong> designation`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("designationid", row.desig_id);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("createdby", authDetails?.user_id);
        dispatch(deleteDesignation(formData));
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Designation" />

          {/* Input Section */}
          {(canCreate || canEdit) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  <Col md="6" lg="6" xl="6">
                    <FormGroup>
                      <Label for="desig_name">
                        Designation <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="desig_name"
                        name="desig_name"
                        type="text"
                        maxLength={50}
                        value={formik.values.desig_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.desig_name &&
                          //Boolean(formik.errors.desig_name)
                          !!formik.errors.desig_name
                        }
                      />
                      {formik.touched.desig_name && formik.errors.desig_name && (
                        <div className="text-danger">{formik.errors.desig_name}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6" lg="6" xl="6" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className=" btn button-save me-2">
                      <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" onClick={handleCancel} className="btn button-cancel">
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col> 
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={designations && designations.length > 0 ? designations : []}
                isGlobalFilter={true}
                customPageSize={10}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Designation;
